import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgShield = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 29,
  viewBox: "0 0 25 29",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("g", {
    filter: "url(#a)",
    children: /*#__PURE__*/_jsx("ellipse", {
      cx: 12.534,
      cy: 24.714,
      fill: "url(#b)",
      rx: 7.284,
      ry: 0.683
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#c)",
    opacity: 0.5,
    style: {
      mixBlendMode: 'multiply'
    },
    children: /*#__PURE__*/_jsx("ellipse", {
      cx: 12.535,
      cy: 24.259,
      fill: "url(#d)",
      rx: 3.187,
      ry: 0.228
    })
  }), /*#__PURE__*/_jsx("path", {
    fill: "#84C888",
    d: "m3.5 4.13 9-3.13 9 3.13v7.675a14.649 14.649 0 0 1-2.542 7.947A14.544 14.544 0 0 1 12.498 25a14.542 14.542 0 0 1-6.458-5.249 14.647 14.647 0 0 1-2.54-7.946V4.13Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "url(#e)",
    d: "m3.5 4.13 9-3.13 9 3.13v7.675a14.649 14.649 0 0 1-2.542 7.947A14.544 14.544 0 0 1 12.498 25a14.542 14.542 0 0 1-6.458-5.249 14.647 14.647 0 0 1-2.54-7.946V4.13Z"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#f)",
    children: /*#__PURE__*/_jsx("path", {
      fill: "url(#g)",
      d: "m5.25 5.733 7.284-2.553 7.285 2.553v6.26a12.013 12.013 0 0 1-2.058 6.483 11.79 11.79 0 0 1-5.228 4.28 11.789 11.789 0 0 1-5.227-4.28 12.012 12.012 0 0 1-2.056-6.483v-6.26Z"
    })
  }), /*#__PURE__*/_jsx("path", {
    stroke: "url(#h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.911,
    d: "M5.705 11.989V6.056l6.83-2.394 6.829 2.394v5.933a11.557 11.557 0 0 1-1.98 6.231 11.339 11.339 0 0 1-4.851 4.042 11.337 11.337 0 0 1-4.85-4.042 11.556 11.556 0 0 1-1.978-6.231Z",
    style: {
      mixBlendMode: 'hard-light'
    }
  }), /*#__PURE__*/_jsxs("g", {
    filter: "url(#i)",
    children: [/*#__PURE__*/_jsx("rect", {
      width: 3.642,
      height: 6.374,
      x: 10.609,
      y: 7.439,
      stroke: "#fff",
      strokeWidth: 0.911,
      rx: 1.821
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 0.911,
      d: "M9.244 10.627h6.374v5.463H9.244z"
    }), /*#__PURE__*/_jsx("rect", {
      width: 1.821,
      height: 1.821,
      x: 11.52,
      y: 12.447,
      fill: "#2E7D32",
      rx: 0.911
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("radialGradient", {
      id: "b",
      cx: 0,
      cy: 0,
      r: 1,
      gradientTransform: "matrix(-6.60156 0 0 -70.4167 12.534 24.486)",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#A5A5A5"
      }), /*#__PURE__*/_jsx("stop", {
        offset: 1,
        stopColor: "#A5A5A5",
        stopOpacity: 0
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "d",
      cx: 0,
      cy: 0,
      r: 1,
      gradientTransform: "matrix(-2.88818 0 0 -23.4722 12.535 24.183)",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#A5A5A5"
      }), /*#__PURE__*/_jsx("stop", {
        offset: 1,
        stopColor: "#A5A5A5",
        stopOpacity: 0
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "e",
      cx: 0,
      cy: 0,
      r: 1,
      gradientTransform: "rotate(69.722 1.982 7.148) scale(18.8272 14.1418)",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        offset: 0.225,
        stopColor: "#E8FFE9"
      }), /*#__PURE__*/_jsx("stop", {
        offset: 0.982,
        stopColor: "#90C993"
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "g",
      cx: 0,
      cy: 0,
      r: 1,
      gradientTransform: "matrix(0 9.31978 -9.19926 0 12.354 12.23)",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#54A057"
      }), /*#__PURE__*/_jsx("stop", {
        offset: 0.894,
        stopColor: "#206724"
      })]
    }), /*#__PURE__*/_jsxs("radialGradient", {
      id: "h",
      cx: 0,
      cy: 0,
      r: 1,
      gradientTransform: "matrix(13.20313 23.90224 -17.77323 9.81758 7.071 1.814)",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#E8FFE9",
        stopOpacity: 0.48
      }), /*#__PURE__*/_jsx("stop", {
        offset: 1,
        stopColor: "#0A1F0B"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "a",
      width: 20.033,
      height: 6.829,
      x: 2.518,
      y: 21.3,
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        result: "effect1_foregroundBlur_2926_10303",
        stdDeviation: 1.366
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "c",
      width: 8.195,
      height: 2.276,
      x: 8.437,
      y: 23.121,
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        result: "effect1_foregroundBlur_2926_10303",
        stdDeviation: 0.455
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "f",
      width: 14.569,
      height: 20.488,
      x: 5.25,
      y: 3.18,
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: 0.911
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: 0.911
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        in2: "shape",
        result: "effect1_innerShadow_2926_10303"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "i",
      width: 12.748,
      height: 15.025,
      x: 6.968,
      y: 6.074,
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), /*#__PURE__*/_jsx("feOffset", {
        dx: 0.911,
        dy: 1.821
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: 1.366
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        values: "0 0 0 0 0.0996528 0 0 0 0 0.341667 0 0 0 0 0.111907 0 0 0 1 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2926_10303"
      }), /*#__PURE__*/_jsx("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2926_10303",
        result: "shape"
      })]
    })]
  })]
});
export default SvgShield;